import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import WhiteLogo from '../../commons/assets/white-logo.png';
import BgDesktop from '../../commons/assets/bg-desktop.png';
import { routes } from '../../core/config/routes';
import style from './general.scss';

const propTypes = {
  /** Proptypes go here */
};
const defaultProps = {
  /** Default Props go here */
};

const GeneralView = ({
  className,
  children,
  logout,
  logoCenter,
  ...otherProps
}) => {


  return (
    <div className={style.general}>

      <img className={classnames(style.bg)} src={BgDesktop} alt='logo coop' />
      <img className={classnames(style.bg)} src={BgDesktop} alt='logo coop' />

      <div className={classnames(style.container)}>

        {/* desktop height 116px */}
        <div className={classnames(style.centered)}>
        <Link to={ routes.truffe.path }>
          <img className={classnames(style.logo)} src={WhiteLogo} alt='logo coop'/>
        </Link>
        </div>



        <div className={classnames(style.content, className)}>
          {children}
        </div>

        {/* desktop height 90px */}
        <div className={style.footer}>
          <p className={style.title}>Alleanza luce & gas S.p.A.</p>
          <p className={style.subtitle}>via Trattati Comunitari Europei 1957-2007, n.13 40127 Bologna – BO Italy – Iscrizione Reg. Imp. C.F. e P.I.03386091205 - REA BO – 515162 - Capitale sociale € 4.850.000 i.v.  </p>
          <p className={style.subtitle}>Società soggetta a direzione e coordinamento da parte di Energia Pulita S.r.l. (C.F.\P.IVA 10802400969)</p>
          <div className={style.links}>
            <Link to={ routes.privacy.path }>Informativa sulla privacy</Link> - <Link to={ routes.policy.path }>Cookie Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

GeneralView.propTypes = propTypes;
GeneralView.defaultProps = defaultProps;

export const General = GeneralView;
